import { glsInjectDynatrace } from '@gls-its-frontends/common/gls-dynatrace';
import { Environment } from '@/enums/environment';

const STAGE_DYNATRACE_RUM_APP_ID: string = 'ce6856498c72f4ce';
const PROD_DYNATRACE_RUM_APP_ID: string = '43b80643b8cf79f3';

const setUpDynatrace = (environment: Environment): void => {
    switch (environment) {
        case Environment.STAGE:
            glsInjectDynatrace(STAGE_DYNATRACE_RUM_APP_ID);
            break;
        case Environment.PROD:
            glsInjectDynatrace(PROD_DYNATRACE_RUM_APP_ID);
            break;
    }
};

export { setUpDynatrace };
